<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
.name{}
</style>



// WEBPACK FOOTER //
// src/App.vue